import handleImpression from './handleImpression';
import handleImpressionForBrand from './handleImpressionForBrand';
const triggerCarouselImpression = (params) => {
    const { trackedProductsOnImpression, articleId } = params;
    const articleEntry = trackedProductsOnImpression.find((entry) => entry.article === articleId);
    let trackedArticles;
    if (params.praConfiguration.BRAND === 'hm') {
        trackedArticles = handleImpression(Object.assign(Object.assign({}, params), { trackedProductsOnImpression: (articleEntry === null || articleEntry === void 0 ? void 0 : articleEntry.trackedArticles) || [] }));
    }
    else {
        trackedArticles = handleImpressionForBrand(Object.assign(Object.assign({}, params), { trackedProductsOnImpression: (articleEntry === null || articleEntry === void 0 ? void 0 : articleEntry.trackedArticles) || [] }));
    }
    if (articleEntry && trackedArticles) {
        const indexValue = trackedProductsOnImpression.findIndex((entry) => entry.article === articleId);
        trackedProductsOnImpression[indexValue] = Object.assign(Object.assign({}, articleEntry), { trackedArticles });
    }
    else if (!articleEntry && trackedArticles) {
        trackedProductsOnImpression.push({
            article: articleId,
            trackedArticles,
        });
    }
    return trackedProductsOnImpression;
};
export default triggerCarouselImpression;
//# sourceMappingURL=triggerCarouselImpression.js.map